import script from "./ProjectTaskIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTaskIndex.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTaskIndex.vue?vue&type=style&index=0&id=5ea1bf6e&lang=css"
import "./ProjectTaskIndex.vue?vue&type=style&index=1&id=5ea1bf6e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea1bf6e"]])

export default __exports__